import { render, staticRenderFns } from "./visit_report_detail.vue?vue&type=template&id=0ffb707e&scoped=true"
import script from "./visit_report_detail.vue?vue&type=script&lang=js"
export * from "./visit_report_detail.vue?vue&type=script&lang=js"
import style0 from "./visit_report_detail.vue?vue&type=style&index=0&id=0ffb707e&prod&lang=scss&scoped=true"
import style1 from "./visit_report_detail.vue?vue&type=style&index=1&id=0ffb707e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffb707e",
  null
  
)

export default component.exports